import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77341f96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-section-wrapper" }
const _hoisted_2 = ["onClick"]

interface Option {
  id: any;
  name: string;
}
interface Props {
  options: Option[];
  modelValue: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchSection',
  props: {
    options: null,
    modelValue: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["switch-section", { active: __props.modelValue === option.id }]),
        key: option.id,
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', option.id))
      }, _toDisplayString(option.name), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})